import axios from "axios"

export const importLegacyYearlySales = async ({ outletId, file, dryRun = false, asOfDate = null }) => {
  const url = `${process.env.REACT_APP_INVENTORY_API_URL}/legacy-sales-yearly/import`

  const formData = new FormData()
  formData.append("outlet_id", outletId)
  formData.append("file", file)
  if (dryRun) formData.append("dry_run", "1")
  if (asOfDate) formData.append("as_of_date", asOfDate)

  const response = await axios.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return response.data
}
